export default "__VITE_ASSET__DfU1gT_Y__";